import { render, staticRenderFns } from "./OpenText.vue?vue&type=template&id=73c3c030"
import script from "./OpenText.vue?vue&type=script&lang=js"
export * from "./OpenText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports